export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6622.d0d02ff9.jpg";